import {
  createMaxMessage,
  createMinMessage,
  createRequiredMessage,
} from "@domain/validations";
import * as Yup from "yup";
import { Material, structuralLayerFunctionData } from "../../materials";
import { TypesMaterialStructure } from "./TypesMaterialStructure";
import { useMemo } from "react";
export const getBuildingComponentValidationSchema = () => {
  const buildingComponentValidationSchema = Yup.object<any>().shape({
    name: Yup.string()
      .min(1, createMinMessage("name", 1))
      .max(100, createMaxMessage("name", 100))
      .required(createRequiredMessage("Name")),
    description: Yup.string()
      .min(1, createMinMessage("description", 1))
      .max(10000, createMaxMessage("description", 10000))
      .required(createRequiredMessage("description")),
  });

  return buildingComponentValidationSchema;
};

/**
 * Functional Component: TypeStructure
 *
 * This component renders the material structure for a type, including material options and structural layer functions.
 *
 * Props:
 * @param {Object} props - The properties passed to the component.
 * @param {any[]} props.materialOptions - An array of material options.
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the material structure.
 */
export const TypeStructure: React.FC<{ materialOptions: any[] }> = ({
  materialOptions,
}) => {
  const mappedFunctionOptions = useMemo(() => {
    return structuralLayerFunctionData.map((item) => {
      return { value: item.type, text: item.function };
    });
  }, []);

  let mappedMaterialOptions: {
    value: string;
    text: string;
  }[] = [];

  if (materialOptions !== undefined) {
    mappedMaterialOptions = materialOptions.map((item: any) => {
      return { value: item.id, text: item.name };
    });
  }

  const materialStructureProps = useMemo(
    () => ({
      viewModel: {
        materialOptions: mappedMaterialOptions,
        functionOptions: mappedFunctionOptions,
      },
    }),
    [materialOptions, mappedFunctionOptions]
  );

  return (
    <div className="mt-3">
      <TypesMaterialStructure {...materialStructureProps} />
    </div>
  );
};
